/* unplugin-vue-components disabled */import { render } from "./tracker-companies.vue?vue&type=template&id=6975a7af"
import script from "./tracker-companies.vue?vue&type=script&lang=js"
export * from "./tracker-companies.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/tracker/tracker-companies.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6975a7af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6975a7af', __exports__)) {
    api.reload('6975a7af', __exports__)
  }
  
  module.hot.accept("./tracker-companies.vue?vue&type=template&id=6975a7af", () => {
    api.rerender('6975a7af', render)
  })

}


export default __exports__